<template>
  <v-autocomplete
    :items="items"
    v-model="selectedDestinationId"
    :label="label"
    item-text="name"
    item-value="id"
    :clearable="clearable"
    @click:clear="clear"
    @change="changeListener($event)"
    prepend-inner-icon="mdi-web"
    :outlined="outlined"
    :disabled="destinationList.length == 0 || disabled"
    :hide-details="hideDetails"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { ALL_DESTINATIONS_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "DestinationListSelect",

  props: {
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    destination: {
      type: Object,
    },
    destinationId: {
      type: String,
    },
    setDefault: {
      type: Boolean,
      default: false,
    },
    locationLabel: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    setRoot: {
      type: Boolean,
      default: () => false,
    },
    customLabel: {
      type: String,
      default: () => "Destination",
    },
    hideNotInUse: {
      type: Boolean,
      default: () => false,
    },
    skipInput: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      destinations: {},
      selectedDestination:
        this.value && this.value != "" ? this.value : this.destination,
      selectedDestinationId:
        this.value && this.value != ""
          ? this.value
          : this.destination
          ? this.destination.id
          : "",
      destinationList: [],
    };
  },

  methods: {
    changeListener(data) {
      if (typeof data === "string") {
        let selectedDest = Object.assign(
          {},
          this.destinationList.find((d) => d.id === data)
        );
        this.selectedDestination = selectedDest;
        this.$emit("onSelect", selectedDest);
      }
      if (!this.skipInput) {
        this.$emit("input", data);
      }
    },
    setRootDestination() {
      const rootDest = Object.assign(
        {},
        this.destinationList.find((d) => d.isRoot)
      );
      if (rootDest) {
        this.selectedDestination = rootDest;
        this.selectedDestinationId = rootDest.id;
        this.$emit("onSelect", rootDest);
      }
    },
    setDefaultDestination() {
      if (
        this.setDefault &&
        this.destinationList.length > 0 &&
        this.selectedDestinationId == ""
      ) {
        const defaultDest = Object.assign(
          {},
          this.destinationList.find((d) => d.isDefault)
        );
        this.selectedDestination = defaultDest;
        this.$emit("onSelect", defaultDest);
        this.$emit("input", defaultDest.id);
      }
    },
    clear() {
      this.$emit("onClear");
    },
    selectById() {
      if (!this.destinationId) {
        this.selectedDestination = null;
      } else if (this.destinationList.length > 0 && this.destinationId != "") {
        const selected = this.destinationList.find(
          (d) => d.id == this.destinationId
        );
        if (selected) this.selectedDestination = { ...selected };
      }
    },
  },

  apollo: {
    destinations: {
      query: ALL_DESTINATIONS_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.destinationList = data.destinations.edges.map((node) => ({
          ...node.node,
        }));

        if (this.setRoot) {
          this.setRootDestination();
        } else if (this.setDefault) {
          this.setDefaultDestination();
        } else if (this.destinationId != "") {
          this.selectById();
        }
      },
    },
  },
  computed: {
    items() {
      return this.hideNotInUse
        ? this.destinationList.filter((d) => {
            if (
              (this.destinationId && this.destinationId != "") ||
              this.destination ||
              this.value != ""
            ) {
              if (this.destinationId && this.destinationId != "") {
                return d.id == this.destinationId || !d.notInUse;
              } else if (this.destination) {
                //console.log("destination", this.destination.id, d.id);
                return d.id == this.destination.id || !d.notInUse;
              } else if (this.value != "") {
                return d.id == this.value || !d.notInUse;
              }
            }
            return !d.notInUse;
          })
        : [...this.destinationList];
    },
    label() {
      if (this.locationLabel) {
        if (this.selectedDestination) {
          return `Location: ${this.selectedDestination.geolocation}`;
        }
      } else {
        return this.customLabel;
      }
    },
  },
  watch: {
    destination(value) {
      this.selectedDestination = value;
      this.selectedDestinationId = value.id;
    },
    destinationId(value) {
      this.selectedDestinationId = value;
    },
    value(newVal) {
      this.selectedDestinationId = newVal;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/DestinationListSelect.vue